import React from 'react';
import { Stack, Typography } from '@mui/material';
import { capitalizeFirstLetter } from 'formatters';

import { Details } from './Details';
import { EMPTY_VALUE, formatEnumText, getChangeAction } from './lib';

interface Props {
  value: Record<string, any>;
}

const formatContactsText = (contacts: Record<string, any>[] | null | undefined): string => {
  if (!contacts?.length) return EMPTY_VALUE;

  return contacts
    .map(contact => contact?.fullName ?? contact?.email)
    .filter(Boolean)
    .join(', ');
};

const getProposalRows = (
  before: Record<string, any> | null | undefined,
  after: Record<string, any> | null | undefined
) => [
  {
    label: 'Send Via',
    before: formatEnumText(before?.sendVia),
    after: formatEnumText(after?.sendVia),
    rawBefore: before?.sendVia,
    rawAfter: after?.sendVia,
  },
  {
    label: 'Send To',
    before: formatContactsText(before?.sendTo),
    after: formatContactsText(after?.sendTo),
    rawBefore: before?.sendTo,
    rawAfter: after?.sendTo,
  },
  {
    label: 'CC Email To',
    before: formatContactsText(before?.ccEmailTo),
    after: formatContactsText(after?.ccEmailTo),
    rawBefore: before?.ccEmailTo,
    rawAfter: after?.ccEmailTo,
  },
  {
    label: 'Notes To Buyer',
    before: before?.notesToBuyer ?? EMPTY_VALUE,
    after: after?.notesToBuyer ?? EMPTY_VALUE,
    rawBefore: before?.notesToBuyer,
    rawAfter: after?.notesToBuyer,
  },
];

export const ProposalChanges = ({ value }: Props) => {
  const { before, after } = value;
  const action = getChangeAction(before, after);

  return (
    <Stack>
      <Typography variant="body2" fontWeight={500}>
        {`${capitalizeFirstLetter(action)}: Proposal`}
      </Typography>

      <Details action={action} rows={getProposalRows(before, after)} />
    </Stack>
  );
};
